module.exports = __webpack_public_path__ + "static/img/item-fyxcx.477e3612.png";